

















import {Component, Vue} from 'vue-property-decorator';
import LoginForm from '@/screens/auth/login/LoginForm.vue';

@Component({
  components: {
    LoginForm
  }
})
export default class LoginScreen extends Vue {
}
